export const environment = {
  production: false,
  api_url:
    'https://ca-dwm-api-dev.greenriver-4fef2c17.westeurope.azurecontainerapps.io',
  identity_url: 'https://identity-dev.data-automation.com',
  realm: 'dwm-dev'
};
